import { useDispatch, useSelector } from 'react-redux';
import { Switch, Typography } from 'antd';

import { editorTypes } from '../../constants/tiptapEditorConstants';

import { updateEditorFullWidth } from '../../store/tiptapEditor.actions';
import { selectEditorFullWidth } from '../../store/tiptapEditor.selectors';

import { selectViewOnlyOutlineData } from '../../../../pages/contentOptimizer/viewOnly/store/viewOnlySettings.selectors';

import './OutlineMoreSettings.scss';

const { Title } = Typography;

const editorType = editorTypes.OUTLINE;

const classes = {
    outlineMoreSettingsWrapper: 'outline-more-settings-wrapper',
    outlineMoreSettingsItem: 'outline-more-setting-item d-flex space-no-wrap',
};

const OutlineEditorMoreSettings = () => {
    const dispatch = useDispatch();

    const viewOnlyMode = useSelector(selectViewOnlyOutlineData);
    const editorFullWidth = useSelector(selectEditorFullWidth(editorType));

    const outlineSettingsItems = [
        {
            title: 'Full Width',
            value: editorFullWidth,
            onChange: (value) =>
                dispatch(
                    updateEditorFullWidth({
                        editorType: editorType,
                        status: value,
                    })
                ),
        },
    ];

    return (
        <div
            className={`${classes.outlineMoreSettingsWrapper}
                        ${viewOnlyMode ? 'view-only' : ''}`}
        >
            {outlineSettingsItems.map((item) => (
                <div key={item.title} className={classes.outlineMoreSettingsItem}>
                    <Switch size='small' onChange={item.onChange} checked={item.value} />
                    <Title level={5}>{item.title}</Title>
                </div>
            ))}
        </div>
    );
};

export default OutlineEditorMoreSettings;
